import React from 'react';
import PropTypes from 'prop-types';
import {Form} from "react-bootstrap";
import BreadcrumbItem from "../../component/BreadcrumbItem/BreadcrumbItem";
import Loading from "../../component/Loading/Loading";
import Page from "../../component/Page/Page";
import Box from "../../component/Box/Box";
import Objects from "../../utils/Objects";
import NotFound from "../../component/NotFound/NotFound";
import Notify from "../../services/Notify";
import UserService from "../../services/UserService";
import ProfileCustomSelect from "../../profile/ProfileCustomSelect";
import FormButtons from "../../component/Form/FormButtons";

class UserProfileSelectPage extends React.Component {

  service = new UserService();

  constructor(props) {
    super(props);
    this.state = {loading: true};
    this.submit = this.submit.bind(this);
  }

  componentDidMount() {
    const {match} = this.props;
    const id = match.params.id;
    if (Objects.isNullOrUndefined(id)) {
      return;
    }
    this.setState({loading: true});
    this.service.findById(id).then(
        data => this.setState(
            {
              loading: false,
              user: data
            }),
        error => {
          const state = {loading: false};
          if (error.response.status === 404) {
            state.message = 'Entidade não encontrada!';
          } else {
            state.message = 'Erro inesperado!';
            Notify.error('Falha o buscar entidade!', error)
          }
          this.setState(state);
        }
    )
  }

  submit(event) {
    event.preventDefault();
    const {history} = this.props;
    const {user} = this.state;

    this.service.saveProfiles(user.id, this.profilesIds).then(
        () => Notify.success('Atualização efetuada') && history.goBack(),
        error => {
          Notify.error('Problema ao associar', error);
        }
    );
  }

  render() {
    const {history} = this.props;
    const {loading, user} = this.state;

    const breadcrumbs = [
      <BreadcrumbItem key={1} title="Cadastro"/>,
      <BreadcrumbItem key={2} title="Lista de Usuários" to="/users"/>,
      <BreadcrumbItem key={3} title="Perfis do Usuário" active={true}/>];

    if (loading) {
      return <Loading/>;
    }

    if (Objects.isNullOrUndefined(user)) {
      return <NotFound/>;
    }
    const profiles = user.profiles || [];
    return (
        <Page title={`Perfis de acesso do usuário(a) "${user.name}"`} breadcrumbs={breadcrumbs}>
          <Box info>
            <Form onSubmit={this.submit}>
              <ProfileCustomSelect companyId={user.company.id} profileIds={profiles.map(({id}) => id)} setValue={(value) => this.profilesIds = value} history={history}/>
              <FormButtons history={this.props.history} style={{marginTop: 10}}/>
            </Form>
          </Box>
        </Page>);
  }
}

UserProfileSelectPage.defaultProps = {
  user: null,
};

UserProfileSelectPage.propTypes = {
  user: PropTypes.object,
  history: PropTypes.object.isRequired,
};

export default UserProfileSelectPage;



// WEBPACK FOOTER //
// ./src/user/application/UserProfileSelectPage.js